import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["appUsageTracker", "disabled", "label", "data-test-id", "report", "trackingProperties", "assetType", "tooltipMessage", "onButtonClick", "dataTestId"];
import I18n from 'I18n';
import { useCallback } from 'react';

// @ts-expect-error Untyped import
import useExportReportProblem from './useExportReportProblem';
import ActionButton from '../ActionButton';
import { EXPORT_REPORT_DIALOG } from '../../dialog/dialogTypes';
// @ts-expect-error Untyped import
import { useShowDialog } from '../../dialog/ducks';
import { EVENTS } from '../../utils/usageTracker';
// @ts-expect-error Untyped import
import { useCurrentUser } from '../../access/useUserInfo';
import { useTracker } from '../../utils/hooks/useTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export const SelectedReports = {
  mainReport: 'main-report',
  summarizedTable: 'summarized-table',
  unsummarizedTable: 'unsummarized-table'
};
const ExportReportButton = _ref => {
  let {
      appUsageTracker,
      disabled: isDisabledViaParentApp = false,
      label = I18n.text('reporting-action-components.actions.exportReport.button.text'),
      'data-test-id': propDataTestId = 'report-action-export-report-button',
      report,
      trackingProperties = {
        interactionSource: 'actions-dropdown'
      },
      assetType = 'report',
      tooltipMessage: appDefinedTooltip = '',
      onButtonClick,
      dataTestId
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const buttonDataTestId = dataTestId || propDataTestId;
  const {
    use,
    size
  } = buttonProps;
  const usageTracker = useTracker(appUsageTracker);
  const {
    problem,
    disabledMessage
  } = useExportReportProblem({
    report
  });
  const showDialog = useShowDialog();
  const isDisabled = isDisabledViaParentApp || !!problem;
  const user = useCurrentUser();
  const userEmail = user && user.get('emails') ? user.get('emails').first() : '';
  const handleExportReportClick = useCallback(args => {
    if (usageTracker) {
      usageTracker.track(EVENTS.clickShareAsset, Object.assign({
        actionType: 'share',
        action: 'export'
      }, trackingProperties, {
        assetType
      }));
    }
    if (onButtonClick) {
      onButtonClick(args);
    }
    showDialog({
      dialogType: EXPORT_REPORT_DIALOG,
      dialogProps: {
        appUsageTracker,
        report,
        userEmail,
        trackingProperties
      }
    });
  }, [trackingProperties, assetType, showDialog, report, appUsageTracker, userEmail, usageTracker, onButtonClick]);
  return /*#__PURE__*/_jsx(ActionButton, {
    use: use,
    size: size,
    dataTestId: buttonDataTestId,
    disabled: isDisabled,
    label: label,
    tooltip: appDefinedTooltip || disabledMessage,
    onClick: handleExportReportClick
  });
};
export default ExportReportButton;